import { Card, CardBody, Col, Input } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FormControlSizings, FormControlSizingsPlaceholder } from "../../../../Constant";
import { FORM_CONTROL_SIZING } from "../../../../Data/FormControl/BaseInput";

const FormControlSizing = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FormControlSizings} span={FORM_CONTROL_SIZING} />
        <CardBody>
          <Input bsSize="sm" type="text" placeholder={FormControlSizingsPlaceholder} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default FormControlSizing;
